/**
 * Error-state placeholder (PHASE1 §7.4): a German message with an optional
 * retry action for failed queries.
 */
import { AlertTriangle } from 'lucide-react';
import { Button } from './Button.tsx';

export interface ErrorStateProps {
  title?: string;
  message?: string;
  error?: unknown;
  onRetry?: () => void;
}

export function ErrorState({
  title = 'Etwas ist schiefgelaufen',
  message,
  error,
  onRetry,
}: ErrorStateProps) {
  const detail = message ?? (error instanceof Error ? error.message : undefined);
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center">
      <AlertTriangle className="h-12 w-12 text-rose-400 dark:text-rose-500" aria-hidden />
      <div className="space-y-1">
        <h3 className="text-base font-semibold text-slate-900 dark:text-slate-100">{title}</h3>
        {detail ? <p className="text-sm text-slate-400 dark:text-slate-500">{detail}</p> : null}
      </div>
      {onRetry ? (
        <div className="mt-3">
          <Button variant="secondary" size="sm" onClick={onRetry}>
            Erneut versuchen
          </Button>
        </div>
      ) : null}
    </div>
  );
}
